export type Pixels = number;

export type Points = number;

export const BROWSER_PIXELS_PER_INCH = 96;

export const PRINT_RECOMMENDED_PIXELS_PER_INCH = 300;
